import i18n from './../../../shared/i18n';
import BaseModel from "./../../components/input-widget/BaseModel";

export default class Premium extends BaseModel {
  amount_over = 0;
  percent = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  getData() {
    return {
      amount_over: parseFloat(this.amount_over),
      percent: parseFloat(this.percent),
    };
  }

  rules = {
    amount_over: 'required',
    percent: 'required|max_value:100|min_value:0',
  };

  attributeLabels = {
    amount_over: i18n.t('Over'),
    percent: i18n.t('Percentage'),
  };
}
